module.exports = __webpack_public_path__ + "static/media/notifications.96b3e334.svg";